export function getView(list) {
  return list?.length ? 'Content' : 'Empty'
}
